export default {
  toasts: {
    load_error: 'Die Rechnungen konnten nicht geladen werden.',
    action_error: 'Die Aktion ist fehlgeschlagen — bitte erneut versuchen.',
    finalized: 'Rechnung finalisiert.',
    marked_paid: 'Rechnung als bezahlt markiert.',
  },
  volume_discount_badge: 'Mengenrabatt angewendet ({{licenses}} Lizenzen, {{percent}} %)',
  filters: {
    status: 'Nach Status filtern',
  },
  columns: {
    description: 'Rechnung',
    status: 'Status',
    total: 'Gesamt',
    paid_at: 'Bezahlt am',
  },
  statuses: {
    pending: 'Ausstehend',
    processing: 'In Bearbeitung',
    paid: 'Bezahlt',
    failed: 'Fehlgeschlagen',
    refunded: 'Erstattet',
    partially_refunded: 'Teilweise erstattet',
  },
  companies: {
    partner_level: 'Korrekturen auf Partnerebene',
    columns: {
      company: 'Restaurant',
      buckets: 'Positionen',
      amount: 'Betrag',
    },
  },
  buckets: {
    license_fees: 'Lizenzgebühren',
    service_fees: 'Servicegebühren',
    processing_fees: 'Zahlungsgebühren',
    delivery_fees: 'Liefergebühren',
    gift_card_fees: 'Gutschein-Gebühren',
    adjustments: 'Korrekturen',
  },
  entries: {
    count: '{{count}} Einträge',
    columns: {
      description: 'Eintrag',
      occurred_at: 'Datum',
      amount: 'Betrag',
    },
  },
  incl_tax: 'inkl. {{amount}} MwSt.',
  actions: {
    open_invoice_pdf: 'Rechnung herunterladen (PDF)',
    open_hosted: 'Rechnung auf Stripe öffnen',
    export_csv: 'CSV exportieren',
    finalize: 'Auf Stripe finalisieren',
    mark_paid: 'Als bezahlt markieren',
  },
  finalize: {
    title: 'Diese Rechnung auf Stripe finalisieren?',
    description:
      'Mit der Finalisierung beginnt der Einzug: Mit hinterlegter Zahlungsmethode wird automatisch abgebucht, andernfalls erhält der Partner die Rechnung per Link.',
    confirm: 'Finalisieren',
  },
  mark_paid: {
    pushed_note:
      'Diese Rechnung liegt bereits bei Stripe — der Entwurf wird gelöscht (bzw. eine finalisierte Rechnung als extern bezahlt markiert), damit Stripe den Einzug stoppt.',
    title: 'Diese Rechnung als bezahlt markieren?',
    description: 'Erfasst eine manuelle (Offline-)Zahlung über {{amount}}. Für Banküberweisungen außerhalb von Stripe.',
    confirm: 'Als bezahlt markieren',
  },
  settlement_badge: {
    paid: 'Umsatzbeteiligung ausgezahlt: {{amount}}',
    other: 'Umsatzbeteiligungs-Auszahlung {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Umsatzbeteiligungs-Auszahlungen',
    retry: 'Erneut versuchen',
    toasts: {
      load_error: 'Die Auszahlungen konnten nicht geladen werden.',
      retry_error: 'Der Versuch ist fehlgeschlagen — bitte erneut versuchen.',
      retry_paid: 'Umsatzbeteiligung ausgezahlt.',
      retry_attempted: 'Versuch ausgeführt — die Auszahlung ist noch nicht durch, bitte Status prüfen.',
    },
    columns: {
      period: 'Zeitraum',
      amount: 'Betrag',
      status: 'Status',
      transfer: 'Transfer',
      paid_at: 'Ausgezahlt am',
      payout: 'Auszahlung',
    },
    payout: {
      direct: '{{amount}}, ohne Umrechnung',
      direct_tooltip:
        'Geschuldet {{owed}}, umgerechnet zu 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} und unverändert gesendet: keine Umrechnung durch Stripe, keine Gebühr.',
      converted: 'Gesendet {{sent}} → eingegangen {{arrived}}',
      expected: 'Gesendet {{sent}} → erwartet {{arrived}}',
      fee: 'Stripe-Umrechnungsgebühr {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'Gebühr und Nettobetrag erscheinen, sobald Stripe den Transfer verbucht hat.',
      tooltip:
        'Geschuldet {{owed}}. Umgerechnet zu 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, vom Plattform-Guthaben in {{source_currency}} gesendet und von Stripe zu 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}} umgerechnet. Stripe zieht beim Eingang {{fee_rate}} % ab.',
    },
    statuses: {
      pending: 'Ausstehend',
      held: 'Zurückgehalten',
      processing: 'In Bearbeitung',
      paid: 'Ausgezahlt',
      failed: 'Fehlgeschlagen',
      reversed: 'Storniert',
    },
    hold_reasons: {
      kyc_incomplete: 'Der Partner hat die Verifizierung des Auszahlungskontos noch nicht abgeschlossen.',
      transfers_inactive: 'Das Auszahlungskonto kann noch keine Transfers empfangen.',
      insufficient_platform_balance: 'Das Plattform-Guthaben deckt diese Auszahlung derzeit nicht.',
      manual_hold: 'Manuell zurückgehalten.',
      missing_fx_rate:
        'Für die Auszahlungswährung ist noch kein Wechselkurs hinterlegt. Es wird automatisch erneut versucht.',
      unsupported_payout_currency:
        'Stripe kann diese Auszahlung vom Plattform-Guthaben nicht in der Währung des Auszahlungskontos leisten.',
      amount_too_small: 'Der geschuldete Betrag liegt unter dem Mindestbetrag, den Stripe in dieser Währung überweist.',
    },
  },
};
